import { connect } from 'react-redux'
import GoinZonesPane from '../../components/services/edit/goinzones/GoinZonesPane'
import { IStoreState, IGoinZoneObject, IZoneObject, GoinZoneShapeType, GeoJsonShapeType } from '../../types'
import {
  createGoinzones,
  getGoinzones,
  removeGoinzone,
  updateGoinzone,
  enableButtons,
  createServiceZoneHotspot
} from 'src/state/actions/goinzones'

const getShape = (
  goinzone: IGoinZoneObject
): {
  shape: any
  shapeType: GeoJsonShapeType
} => {
  let shape: any = goinzone.geojson
  let shapeType: any = goinzone.type
  switch (goinzone.type) {
    case GoinZoneShapeType.SHAPE_POLYGON:
    case GeoJsonShapeType.SHAPE_POLYGON:
      shape = {
        type: GeoJsonShapeType.SHAPE_MULTIPOLYGON,
        coordinates: [goinzone.geojson]
      }
      shapeType = GoinZoneShapeType.SHAPE_MULTIPOLYGON
      break
    case GoinZoneShapeType.SHAPE_MULTIPOLYGON:
    case GeoJsonShapeType.SHAPE_MULTIPOLYGON:
      shape = {
        type: GeoJsonShapeType.SHAPE_MULTIPOLYGON,
        coordinates: goinzone.geojson
      }
      shapeType = GoinZoneShapeType.SHAPE_MULTIPOLYGON
      break
  }
  return {
    shape,
    shapeType
  }
}

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const serviceId = ownProps.match.params.id || state.service.metadata.edit.serviceId
  const { designatedHotspotsEnabled } = state.service.items[serviceId] || Number('0')

  return {
    zones: state.goinzones.items,
    orgId: state.organizations.currentOrgId,
    viewMode: ownProps.viewMode,
    serviceId,
    designatedHotspotsEnabled
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    addGoinZone: (goinzone: IGoinZoneObject, orgId: string, serviceId: string) => {
      return new Promise((approve, reject) => {
        //TODO fix this later
        const { shape, shapeType } = getShape(goinzone)
        const zoneObj: IZoneObject = {
          organizationId: orgId,
          serviceId,
          name: goinzone.name,
          color: goinzone.color,
          type: goinzone.zoneType,
          shapeType,
          description: goinzone.description,
          address: goinzone.address,
          radius: goinzone.radius,
          center: {
            type: GeoJsonShapeType.SHAPE_POINT,
            coordinates: [goinzone.coordinates.lng, goinzone.coordinates.lat]
          },
          shape
        }
        dispatch(createGoinzones(zoneObj, orgId, serviceId)).then(() => {
          dispatch(getGoinzones(orgId, serviceId)).then(() => {
            approve()
          })
        })
      }) //
    },
    addGoinZoneHotspot: (goinzone: IGoinZoneObject, orgId: string, serviceId: string) => {
      console.log('mapDispatchToProps', goinzone)
      return new Promise((approve, reject) => {
        const { shape, shapeType } = getShape(goinzone)
        const zoneObj: IZoneObject = {
          organizationId: orgId,
          serviceId,
          name: goinzone.name,
          color: goinzone.color,
          type: goinzone.zoneType,
          shapeType,
          description: goinzone.description,
          address: goinzone.address,
          radius: goinzone.radius,
          center: {
            type: GeoJsonShapeType.SHAPE_POINT,
            coordinates: [goinzone.coordinates.lng, goinzone.coordinates.lat]
          },
          shape,
          zoneId: goinzone.zoneId ? goinzone.zoneId : undefined,
          coordinates: {
            latitude: goinzone.coordinates.lat,
            longitude: goinzone.coordinates.lng
          }
        }
        dispatch(createServiceZoneHotspot(zoneObj, orgId, serviceId)).then(() => {
          dispatch(getGoinzones(orgId, serviceId)).then(() => {
            approve(true)
          })
        })
      }) //
    },
    removeGoinZone: (id: string, orgId: string, serviceId: string) => {
      return new Promise((approve, reject) => {
        dispatch(removeGoinzone(id)).then(() => {
          dispatch(getGoinzones(orgId, serviceId)).then(() => {
            approve()
          })
        })
      })
    },
    updateGoinZone: (goinzone: IGoinZoneObject, orgId: string, serviceId: string) => {
      const { shape, shapeType } = getShape(goinzone)
      const zoneObj: IZoneObject = {
        id: goinzone.id,
        organizationId: orgId,
        serviceId,
        name: goinzone.name,
        color: goinzone.color,
        type: goinzone.zoneType,
        shapeType,
        description: goinzone.description,
        address: goinzone.address,
        radius: goinzone.radius,
        center: {
          type: GeoJsonShapeType.SHAPE_POINT,
          coordinates: [goinzone.coordinates.lng, goinzone.coordinates.lat]
        },
        shape
      }
      return new Promise((approve, reject) => {
        dispatch(updateGoinzone(zoneObj, orgId, serviceId)).then(() => {
          dispatch(getGoinzones(orgId, serviceId)).then(() => {
            approve()
          })
        })
      })
    },
    getGoinzones: (orgId: string, serviceId: string) => {
      return dispatch(getGoinzones(orgId, serviceId))
    },
    enableButtons: (flag: boolean) => {
      return dispatch(enableButtons(flag))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GoinZonesPane)



// WEBPACK FOOTER //
// ./src/containers/services/GoinZonesPane.ts